import { keyframes } from '@mui/system';

// Same as the app: the icon lands with a small bounce and shrinks away.
const pauseEnter = keyframes`
  from { opacity: 0; transform: scale(1.7); }
  to { opacity: 1; transform: scale(1); }
`;

const pauseExit = keyframes`
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(0.6); }
`;

const pause = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '14vw',
  height: '14vw',
  mt: '-7vw',
  ml: '-7vw',
  fontSize: '14vw',
  color: 'rgba(255, 255, 255, 0.5)',
  pointerEvents: 'none',
  '& svg': {
    display: 'block',
    width: '100%',
    height: '100%',
  },
};

const styles = {
  slide: {
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
  },
  pauseIn: {
    ...pause,
    animation: `${pauseEnter} 145ms cubic-bezier(0.34, 1.9, 0.64, 1) both`,
  },
  pauseOut: {
    ...pause,
    animation: `${pauseExit} 94ms cubic-bezier(0.55, 0.085, 0.68, 0.53) both`,
  },
};

export default styles;
